import { render, staticRenderFns } from "./CustomerAddressList.vue?vue&type=template&id=4c34ca28&lang=pug&"
import script from "./CustomerAddressList.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomerAddressList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomerAddressList.vue?vue&type=style&index=0&id=4c34ca28&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports